import { useLanguage } from '@/localization/useLanguage';
import PropTypes from 'prop-types';
import './ExternalBadge.scss';

/**
 * ExternalBadge component.
 * Displays a tag for users who are outside the local organization domain.
 */
export const ExternalBadge = ({ isExternalUser, className = '' }) => {
   const { t } = useLanguage();
   if (!isExternalUser) return null;
   return <span className={`external-badge ${className}`}>{t('invite.EXTERNAL')}</span>;
};

ExternalBadge.propTypes = {
   isExternalUser: PropTypes.bool,
   className: PropTypes.string,
};
